export enum TrainingDurations {
  OneHourNormal = 0.1,
  OneDotFiveHourHard = 0.2,
  TwoHourIntense = 0.3,
  TwoOrMoreHour = 0.4,
}
